import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
import HomePage from './components/HomePage';

export default [
	new Extend.Model(User) //
		.attribute<number>('recentPostsCount'),

	new Extend.Routes() //
		.add('home', '/home', HomePage),
];
